var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 252,
    height: 69,
    viewBox: "0 0 128 35",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "2700ms",
    begin: "0s",
    repeatCount: "indefinite",
    keyTimes: "0;0.167;0.5;0.668;1",
    values: "0.3;1;1;0.3;0.3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 110.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "2700ms",
    begin: "0s",
    repeatCount: "indefinite",
    keyTimes: "0;0.334;0.5;0.835;1",
    values: "0.3;0.3;1;1;0.3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 64,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "2700ms",
    begin: "0s",
    repeatCount: "indefinite",
    keyTimes: "0;0.167;0.334;0.668;0.835;1",
    values: "0.3;0.3;1;1;0.3;0.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingDots);
export default __webpack_public_path__ + "static/media/loadingDots.79f99affdcae3171fd4689860c084296.svg";
export { ForwardRef as ReactComponent };